const tips = [
  {
    icon: 'ri-shirt-line',
    title: 'Roupa confortável e básica',
    desc: 'Sem exageros. Vista-se de forma simples e natural para não interferir na avaliação.',
  },
  {
    icon: 'ri-user-smile-line',
    title: 'Visual natural',
    desc: 'Meninas podem ir com cabelo preso ou solto. Evite maquiagem excessiva ou acessórios em demasia.',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Mantenha a calma',
    desc: 'Seja confiante e saiba por que está participando. Não é necessário ter experiência prévia.',
  },
  {
    icon: 'ri-parent-line',
    title: 'Menores de idade',
    desc: 'Devem estar acompanhados de um responsável maior de idade. Consentimento dos pais é obrigatório.',
  },
];

export default function EventInfoSection() {
  return (
    <section className="px-4 sm:px-5 pb-6">
      <div className="max-w-2xl mx-auto">

        {/* Header */}
        <div className="text-center mb-6">
          <p
            className="text-xs font-bold uppercase tracking-widest mb-2"
            style={{ color: '#EAB308', fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.22em' }}
          >
            Prepare-se
          </p>
          <h2
            className="text-xl sm:text-2xl font-black text-white leading-tight"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Como comparecer à seleção
          </h2>
        </div>

        {/* Tips grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-5">
          {tips.map((tip) => (
            <div
              key={tip.title}
              className="flex items-start gap-4 rounded-2xl px-5 py-4 transition-all duration-300"
              style={{
                background: 'linear-gradient(145deg, #111111, #0a0a0a)',
                border: '1px solid rgba(234,179,8,0.18)',
              }}
              onMouseEnter={e => {
                (e.currentTarget as HTMLDivElement).style.borderColor = 'rgba(234,179,8,0.5)';
              }}
              onMouseLeave={e => {
                (e.currentTarget as HTMLDivElement).style.borderColor = 'rgba(234,179,8,0.18)';
              }}
            >
              <div
                className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0 mt-0.5"
                style={{ background: 'linear-gradient(135deg, #EAB308, #CA8A04)' }}
              >
                <i className={`${tip.icon} text-sm text-black`} />
              </div>
              <div>
                <p
                  className="text-sm font-black text-white mb-1"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  {tip.title}
                </p>
                <p
                  className="text-xs leading-relaxed"
                  style={{ color: '#6B7280', fontFamily: 'Montserrat, sans-serif', fontWeight: 300 }}
                >
                  {tip.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Contact confirmation notice */}
        <div
          className="rounded-2xl px-5 py-5 mb-3"
          style={{
            background: 'linear-gradient(145deg, rgba(234,179,8,0.12) 0%, rgba(234,179,8,0.04) 100%)',
            border: '1.5px solid rgba(234,179,8,0.5)',
          }}
        >
          <div className="flex items-center gap-3 mb-3">
            <div
              className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0"
              style={{ background: 'linear-gradient(135deg, #EAB308, #CA8A04)' }}
            >
              <i className="ri-phone-fill text-sm text-black" />
            </div>
            <p
              className="text-xs font-black uppercase tracking-widest"
              style={{ color: '#EAB308', fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.16em' }}
            >
              Confirmação de presença
            </p>
          </div>
          <p
            className="text-sm leading-relaxed mb-3"
            style={{ color: '#D1D5DB', fontFamily: 'Montserrat, sans-serif', fontWeight: 400 }}
          >
            Nosso time entrará em contato pelo{' '}
            <strong className="text-white font-semibold">WhatsApp ou ligação</strong>{' '}
            com DDD <strong className="text-white font-semibold">053</strong> para confirmar a sua presença.
          </p>
          <div className="flex items-start gap-2">
            <i className="ri-checkbox-circle-fill mt-0.5 flex-shrink-0" style={{ color: '#EAB308', fontSize: '1rem' }} />
            <p
              className="text-sm leading-relaxed"
              style={{ color: '#D1D5DB', fontFamily: 'Montserrat, sans-serif', fontWeight: 400 }}
            >
              Basta <strong className="text-white font-semibold">comparecer na data, horário e local</strong> indicados na sua seleção.
            </p>
          </div>
        </div>

        {/* Important notice */}
        <div
          className="rounded-2xl px-5 py-4 flex items-start gap-4"
          style={{
            background: 'linear-gradient(145deg, rgba(234,179,8,0.07) 0%, #0a0a0a 100%)',
            border: '1px solid rgba(234,179,8,0.18)',
          }}
        >
          <div
            className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0 mt-0.5"
            style={{ background: 'linear-gradient(135deg, #EAB308, #CA8A04)' }}
          >
            <i className="ri-information-fill text-sm text-black" />
          </div>
          <div>
            <p
              className="text-xs font-black uppercase tracking-widest mb-1"
              style={{ color: '#EAB308', fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.16em' }}
            >
              Lembre-se
            </p>
            <p
              className="text-sm leading-relaxed"
              style={{ color: '#9CA3AF', fontFamily: 'Montserrat, sans-serif', fontWeight: 300 }}
            >
              Não há desfile, não é preciso decorar texto nem apresentar book fotográfico. O objetivo é identificar{' '}
              <strong className="text-white font-semibold">novos talentos</strong> de forma natural e autêntica.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
